<template>
  <div class="container">
    <span style=" margin-right: 2px; font-size: 0.8em;">Concentration of selected populations</span>
    <span v-if="geotype === 'CensusTract'" title="Tracts with zero population are not selectable."
          style=" float:right; padding: 3px; font-size: 0.6em; background: #ffffff; border: black solid 1px; cursor: default;">N/A</span>
    <div class="legendNames"
         v-bind:style="{gridTemplateColumns: '0.5fr repeat(' + (2 * (colorLegendData.length - 1)) + ', 1fr) 0.5fr'}"
    >
          <span
            v-for="legend in colorLegendData"
            v-bind:key="legend.value+'-number'"
            v-bind:style="{backgroundColor: legend.value, opacity: legend.visibility ? 0.9 : 0.2,  border: legend.visibility ? 'black solid 1px' : ''}"
            v-on:click="$emit('filterChange', legend.key)"
          >{{legend.label}}</span>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'CategoricalLegend',
    props: [
      "colorLegendData",
      'geotype',
    ],
  }
</script>
<style scoped>
  .container {
    grid-column: 1 / -1;
  }
  .legendNames span {
    grid-column-end: span 2;
  }
  .legendNames span.dash {
    grid-column-end: span 1;
    font-weight: bold;
  }
  .legendNames {
    display: grid;
    width: 100%;
    grid-gap: 2px;
    text-align: center;
    font-size: 0.8em;
    text-shadow: 1px 1px 1px #f8f6f6;
    margin-top: 7px;
  }
  .legendNames span {
    grid-column-end: span 2;
  }

    div.container {
    width: 375px;
    max-width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    padding: 7px;
    margin: 0 10px 10px 0;
    pointer-events: auto;
    border-radius: 15px;
  }


</style>
